import {
  Box,
  Container,
  CssBaseline,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import { routeModules } from "../../config/routeconfig";
import Loading from "../../common/Laoding";
import { useNavigate } from "react-router-dom";
import Bookingledger from "./Bookingledger";


const Bookingledgermodule = () => {
  const navigate = useNavigate();

  const navItems = routeModules?.bookingledger?.sidebar || [];

  const [activeItem, setActiveItem] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!activeItem && navItems.length > 0) {
      setActiveItem(navItems[0].label);
    }
  }, [navItems, activeItem]);

  const renderContent = () => {
    switch (activeItem) {
      case "Booking Ledger":
        return <Bookingledger/>;  
      default:
        return <Typography>Need Access</Typography>;
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) return <Loading />;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      <Layout
        module={"bookingledger"}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          backgroundImage: "linear-gradient(to top, #ffffff, #d4dfed)",
          width: "50%",
        }}
      >
        <Toolbar />

        <Container
          maxWidth={false}
          sx={{ flexGrow: 1, minHeight: "100vh", overflow: "hidden" }}
        >
          {renderContent()}
        </Container>
      </Box>
    </Box>
  );
};

export default Bookingledgermodule;